import React from "react";
import { format, parseISO } from "date-fns";
import { AuditLog } from "@common/types/auditLog";
import { fullDateFullYearFormat } from "@common/helpers/date";
import styles from "./ChatTaskAuditLog.module.scss";

interface Props {
    log: AuditLog;
}

export const ChatTaskDueDate: React.FC<Props> = ({ log }) => {
    const newDueDate = log.diff.find((d) => d.field === "dueDate")?.after
        ?.value;
    const formattedDate = newDueDate
        ? format(parseISO(newDueDate), fullDateFullYearFormat)
        : "";

    if (!formattedDate) {
        return (
            <>
                <span className={styles.chatTaskMessage}>
                    removed the due date
                </span>
            </>
        );
    }

    return (
        <>
            <span className={styles.chatTaskMessage}>
                changed the due date to&nbsp;<strong>{formattedDate}</strong>
            </span>
        </>
    );
};
